import React from "react";

function TradingBotHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover text-center flex items-start"
        style={{
          backgroundImage:
            "url(assets/img/bg/decentralized_exchange_development_img.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "80vh",
        }}
      >
        <div className="container mx-auto px-4 pt-[270px] pb-20">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-4xl md:text-6xl font-bold leading-tight mb-6">
              Crypto Trading Bot Development
            </h2>

            <p className="text-lg md:text-xl text-gray-200 leading-relaxed">
              Xeer Technology specializes in developing advanced crypto trading
              bots tailored to optimize trading strategies and deliver faster,
              more precise market executions. Our bots are designed for both
              beginners and experienced traders, empowering them to automate
              trading, capture market opportunities, and maximize returns in the
              volatile crypto market!
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default TradingBotHero;
